import React, { useState, useEffect } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import WorkflowItem from './WorkflowItem';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import WorkflowToolbar from './WorkFlowToolbar';
import WorkflowSortToolbar from './WorkFlowSortToolbar';
import WorkflowSortCategoriesToolbar from './WorkFlowSortCategoriesToolbar';
import { getActiveWorkflow } from './services/WorkFlowListService';
import './workflow.css';
import { fetchWorkflows } from '.././Home/services/homeService';
import { COMAPANY_ID, CLIENT_NAME } from '../../constants/companyConfig';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const WorkflowList = ({
  workflows,
  handleWorkflowClick,
  handleDeleteWorkflow,
  setWorkflows,
  isAllowed,
  getAuthSDK
}) => {
  // const [workflows, setWorkflows] = useState(workflows_o);

  const navigate = useNavigate();
  const { token, handleLogout } = useAuth();

  useEffect(() => {
    (async () => {
      console.log('Fetching workflows for CLIENT_NAME:', CLIENT_NAME);
      console.log('Using COMPANY_ID:', COMAPANY_ID);
      const data = await fetchWorkflows(token, null, handleLogout);
      console.log('Workflows received:', data);
      setWorkflows(data);
    })();
  }, [token, handleLogout]);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortOption, setSortOption] = useState('last updated');
  const [sortStatusOption, setStatusSortOption] = useState('');
  const [sortCategoryOption, setSortCategoryOption] = useState('');

  const handleSearch = (term) => setSearchTerm(term);
  const handleSort = (option) => setSortOption(option);
  const handleStatusSort = (option) => setStatusSortOption(option);
  const handleCategorySort = (option) => setSortCategoryOption(option);

  const [preRegistration, setPreRegistration] = useState({});
  const [selfSignUp, setSelfSignUp] = useState({});
  // Filter and sort workflows

  useEffect(() => {
    getSelectedWorkflow();
  }, []);
  useEffect(() => {
    (async () => {
      const data = await fetchWorkflows(token, null, handleLogout);
      setWorkflows(data);
    })();
  }, [sortStatusOption]);

  const handleClick = () => {
    getAuthSDK(); // calls parent's method
  };

  const filteredWorkflows = workflows
    .filter((workflow) =>
      workflow.workflow_name.toLowerCase().includes(searchTerm)
    )
    .filter(
      (workflow) =>
        !sortStatusOption || // If sortStatusOption is null, keep all
        workflow.workflow_status?.trim().toUpperCase() ===
          sortStatusOption.toUpperCase()
    )
    .filter(
      (workflow) =>
        //console.log(workflow.workflow_category,sortCategoryOption,'workflow')
        //(workflow.workflow_category && workflow.workflow_category.toLowerCase().includes(sortCategoryOption.toLowerCase()))
        !sortCategoryOption ||
        sortCategoryOption === 'all-categories' ||
        (workflow.workflow_category &&
          workflow.workflow_category
            .toLowerCase()
            .includes(sortCategoryOption.toLowerCase()))
    )
    .filter(
      (workflow) =>
        sortOption !== 'active' ||
        workflow.workflow_status?.trim().toLowerCase() === 'active'
    )
    .sort((a, b) => {
      // Then sort by selected option
      if (sortOption === 'last updated') {
        return new Date(b.updated_at) - new Date(a.updated_at);
      } else if (sortOption === 'created date') {
        return new Date(b.created_at) - new Date(a.created_at);
      } else if (sortOption === 'name') {
        return a.workflow_name.localeCompare(b.workflow_name);
      } else if (sortOption === 'active') {
        return a.workflow_status.localeCompare(b.workflow_status);
      }
      return 0;
    });

  /*const filteredWorkflows = workflows
    .filter((workflow) =>
      workflow.workflow_name.toLowerCase().includes(searchTerm)
    )
    .sort((a, b) => {
      if (sortOption === 'last updated') {
        return new Date(b.updated_at) - new Date(a.updated_at);
      } else if (sortOption === 'created date') {
        return new Date(b.created_at) - new Date(a.created_at);
      } else if (sortOption === 'name') {
        return a.workflow_name.localeCompare(b.workflow_name);
      }
      return 0;
    });*/

  const getSelectedWorkflow = async () => {
    const response = await getActiveWorkflow(token);

    const preRegistration =
      response?.[0]?.signup_options?.pre_registration?.filter(
        (item) => item.status === true
      );
    const selfSignUp = response?.[0]?.signup_options?.self_sign_up?.filter(
      (item) => item.status === true
    );

    setPreRegistration(preRegistration?.[0]?.id);
    setSelfSignUp(selfSignUp?.[0]?.id);
  };

  const [imageMap, setImageMap] = useState({});

  useEffect(() => {
    const fetchImageUrls = async () => {
      if (!filteredWorkflows.length) return;

      const params = new URLSearchParams();
      filteredWorkflows.forEach((wf) => params.append('wfwIds[]', wf.id));
      params.append('companyId', COMAPANY_ID.toString());
      params.append('type', 'image');
      params.append('purpose', 'workflow_image');

      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/workflows/download/urls?${params.toString()}`,
          {
            method: 'GET',
            headers: {
              Accept: 'application/json',
              Authorization: `${token}`,
            },
          }
        );

        // const data = await response.json();
        const apiResponse = await response.json();
        const data = apiResponse.data;

        // Assuming API returns a list of objects: [{ wfwId: 'id1', downloadUrl: 'url1' }, ...]
        const map = {};
        (data || []).forEach((item) => {
          if (item.wfwId && item.downloadUrl) {
            map[item.wfwId] = item.downloadUrl;
          }
        });

        setImageMap(map);
      } catch (error) {
        console.error('Error fetching workflow images:', error);
      }
    };

    fetchImageUrls();
  }, [workflows]);

  return (
    <div>
      <div
        style={{ display: 'flex', textAlign: 'right', marginBottom: '10px' }}
      >
        {/* Pass handleSearch and handleSort to WorkflowToolbar */}
        <WorkflowToolbar onSearch={handleSearch} onSort={handleSort} />
        <WorkflowSortToolbar
          onSearch={handleSearch}
          onSort={handleStatusSort}
        />
        <WorkflowSortCategoriesToolbar
          onSearch={handleSearch}
          onSort={handleCategorySort}
        />
        {
          <button
          style={{
            padding: '8px 16px',
            backgroundColor: ' var(--primary-color)',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            marginLeft: 'auto',
          }}
          onClick={async () => {
              // Wait for handleClick to finish
              const allowed = await getAuthSDK();

              if (!allowed) {
                toast.warning(
                  "Sorry, you don't have permission to access this. Please contact the administrator for access.",
                  {
                    position: "top-right",
                    autoClose: 3000,
                  }
                );
                return; // stop further execution
              }

              // Only if allowed, proceed with navigation
              const newWorkflowId = (workflows.length + 1).toString();
              const newWorkflowName = `Workflow ${workflows.length + 1}`;
              navigate(`/workflow/create`, {
                state: {
                  workflow: { nodes: [], edges: [] },
                  workflowId: newWorkflowId,
                  workflowName: newWorkflowName,
                  isNewWorkflow: true,
                },
              });
            }}
          >
          <AiOutlinePlus style={{ display: 'inline', marginRight: '5px' }} />{' '}
          Create Workflow
        </button>
        }
      </div>
      {filteredWorkflows.length > 0 ? (
        <div className="workflow-grid">
          {filteredWorkflows.map((workflow, index) => (
            <WorkflowItem
              key={workflow.id}
              title={workflow.workflow_name}
              created_at={workflow.created_at}
              updated_at={workflow.updated_at}
              /* description={`Workflow ${index + 1}: ${workflow.workflow_description}`}*/
              description={`${workflow.workflow_description}`}
              onClick={() => handleWorkflowClick(workflow)}
              onDelete={() => handleDeleteWorkflow(workflow.id)}
              wid={workflow.id}
              workflow_category={workflow.workflow_category}
              workflow_description={workflow.workflow_description}
              workflow_icon={workflow.workflow_icon}
              isactive={workflow.workflow_status}
              isSelectedWorkflow={
                preRegistration === workflow.id || selfSignUp === workflow.id
              }
              nodes={workflow.workflow.nodes}
              edges={workflow.workflow.edges}
              status={workflow.portal_status}
              wf_image_name={workflow.workflow_image}
              wf_image={imageMap[workflow.id]}
            />
          ))}
        </div>
      ) : (
        <div style={{ textAlign: 'center', padding: '20px', color: '#888' }}>
          No workflows available
        </div>
      )}
    </div>
  );
};

export default WorkflowList;
